export function DailyBookingChartCtrl (
  $scope,
  $state,
  $stateParams,
  $translate,
  workshopAPI,
  dateParsing,
  messages
) {

  $scope.date = $stateParams.date;

  $scope.chart = {
    type: 'ComboChart',
    data: {},
    options: {
      width: '75%',
      height: 300,
      isStacked: true,
      fill: 20,
      displayExactValues: true,
      seriesType: 'bars',
      animation: {
        duration: 500,
        easing: 'linear',
        startup: true
      },
      chartArea: {
        width: '75%'
      },
      vAxis: {
        gridlines: {
          count: 5
        }
      }
    }
  };

  $scope.saveHours = function () {
    workshopAPI.post('/work_hours', {
      date: $scope.date,
      available_hours: $scope.availableHours
    }, 'work_hour').then(function (data) {
      $scope.availableHours = data.available_hours;
      messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.HOURS'), 'success');
    }, function (err) {
      messages.error(err);
    });
  };

  $scope.viewMechanicEvents = function (a) {
    if (!a) {
      return;
    }

    var date = $scope.chart.data.rows[a.row].c[a.column].date;
    var id = $scope.chart.data.rows[a.row].c[a.column].id;

    if (a.column === 1) {
      return;
    }

    $state.go('app.event-items', {
      id  : id,
      date: date
    });
  };

  $scope.buildColumns = function (job) {
    var cols = [{
      id: 'header',
      label: $translate.instant('JS_SPACE.TABS.DAY'),
      type: 'string'
    }, {
      id: 'defaultHours',
      label: $translate.instant('JS_SPACE.BOOKINGS.DEFAULT_WORK_HOURS'),
      type: 'number'
    }];

    var series = [{
      type: 'line',
      color: '#F61C19'
    }]

    angular.forEach(job.mechanics, function (mechanic, i) {
      var contains = $.grep(cols, function (col) {
        return col.id === mechanic.mechanic;
      });

      if (!contains.length) {
        cols.push({
          id: mechanic.mechanic || 'unassigned',
          label: mechanic.display_name || $translate.instant('JS_SPACE.BOOKINGS.UNASSIGNED'),
          type: 'number'
        });

        series.push({
          type: 'bars',
          color: '#805432'
        });
      }
    });

    $scope.chart.options.series = series;
    $scope.chart.data.cols = cols;
  };

  $scope.buildRows = function (job) {
    var rows = [{
      c: []
    }, {
      c: []
    }, {
      c: []
    }];

    angular.forEach($scope.chart.data.cols, function (col, i) {

      if (!i) {
        var dayOfWeek = moment($scope.date).day();

        rows[0].c.push({
          v: ' '
        });

        rows[1].c.push({
          v: dateParsing.getDayName(dayOfWeek + 1)
        });

        rows[2].c.push({
          v: '  '
        });
      }
      else if (i === 1) {
        rows[0].c.push({
          v: parseInt($scope.availableHours)
        });

        rows[1].c.push({
          v: parseInt($scope.availableHours)
        });
        rows[2].c.push({
          v: parseInt($scope.availableHours)
        });
      }
      else {
        var matchingMechanic = job.mechanics.filter(function (mechanic) {
          return (mechanic.mechanic || 'unassigned') === col.id;
        });

        if (matchingMechanic.length) {
          rows[1].c.push({
            v: matchingMechanic[0].total_hours || 0,
            f: (matchingMechanic[0].total_hours ? matchingMechanic[0].total_hours.toString(): '0') + ' ' + $translate.instant('VEHICLE_SPACE.HOURS'),
            id: matchingMechanic[0].mechanic || 'unassigned',
            date: $scope.date
          });
        }
        else {
          rows[1].c.push({
            v: 0,
            id: col.id,
            date: $scope.date
          });
        }

        rows[0].c.push({
          v: null
        });
        rows[2].c.push({
          v: null
        });

      }
    });

    $scope.chart.data.rows = rows;
  };

  $scope.buildChart = function (events) {
    $scope.buildColumns(events);
    $scope.buildRows(events);
  };

  $scope.buildChart($scope.chartData.days[0]);

  $scope.$watch('availableHours', function (hours) {
    angular.forEach($scope.chart.data.rows, function (row) {
      row.c[1].v = hours;
    })
  })

}